import PropTypes from 'prop-types'
import styled from 'styled-components'
import { FadeBackground } from '../style'

const Container = styled.div`
  position: absolute;
  bottom: 10%;
  left: 0;
  right: 0;
  width: fit-content;
  margin: 0 auto;
`

const Wrapper = styled(FadeBackground)`
  color: #fff;
`

const Counter = ({ activeIndex = null, total = null }) => {
  if (!activeIndex || !total) {
    return null
  }

  return (
    <Container data-testid="carousel-counter">
      <Wrapper>
        {activeIndex} av {total}
      </Wrapper>
    </Container>
  )
}

Counter.propTypes = {
  activeImage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  total: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default Counter
